var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyListCheckWhite = function SvgMyListCheckWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m.386 7.854 6.121 6.809c.188.212.45.325.737.337.288 0 .55-.112.737-.325l11.88-12.78c.375-.4.35-1.036-.05-1.411a1.003 1.003 0 0 0-1.411.05L7.257 12.514 1.86 6.518A.993.993 0 0 0 .45 6.443c-.4.362-.438 1-.063 1.411"
  })));
};
export default SvgMyListCheckWhite;